<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-slider--nav" }, [
    _c("ul", { staticClass: "tab-slider--tabs" }, [
      _c(
        "li",
        {
          staticClass: "tab-slider--trigger buy1",
          class: _vm.isActive === 1 ? "active" : "",
          attrs: { rel: 1 },
          on: {
            click: function ($event) {
              return _vm.changeTab(1)
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.tabText1) + " ")]
      ),
      _c(
        "li",
        {
          staticClass: "tab-slider--trigger sell1",
          class: _vm.isActive === 2 ? "active" : "",
          attrs: { rel: 2 },
          on: {
            click: function ($event) {
              return _vm.changeTab(2)
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.tabText2) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/tabs/Tabs.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {},
  props: {
    tabText1: {
      type: String,
      default: ""
    },
    tabText2: {
      type: String,
      default: ""
    },
    handleTabChange: {
      type: Function,
      default: () => {}
    },
    selectedTab: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isActive: this.selectedTab
    };
  },
  watch: {
    selectedTab(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isActive = this.selectedTab;
        if (newVal === 2) {
          document.querySelector(".tab-slider--tabs").classList.add("slide");
        } else {
          document.querySelector(".tab-slider--tabs").classList.remove("slide");
        }
      }
    }
  },
  // isActive: false,
  methods: {
    changeTab(tab) {
      this.isActive = tab;
      if (tab === 2) {
        this.handleTabChange(2);
        document.querySelector(".tab-slider--tabs").classList.add("slide");
      } else {
        this.handleTabChange(1);
        document.querySelector(".tab-slider--tabs").classList.remove("slide");
      }
    },
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    selectThirdRow() {
      this.$refs.selectableTable.selectRow(2);
    },
    unselectThirdRow() {
      this.$refs.selectableTable.unselectRow(2);
    }
  }
});

//# sourceURL=webpack:///./src/@core/components/tabs/Tabs.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
[dir=ltr] .tab-slider--nav {
  float: left;
}[dir=rtl] .tab-slider--nav {
  float: right;
}
.tab-slider--tabs {
  display: block;
  list-style: none;
  position: relative;
  overflow: hidden;
  height: 44px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
[dir] .tab-slider--tabs {
  margin: 0;
  padding: 0;
  border-radius: 5px;
  background: #fff;
  border: 2px solid #8dc540;
}
[dir=ltr] .tab-slider--tabs {
  float: right;
}
[dir=rtl] .tab-slider--tabs {
  float: left;
}
.tab-slider--tabs:after {
  content: "";
  width: 50%;
  height: 100%;
  position: absolute;
  top: 0;
  transition: all 250ms ease-in-out;
}
[dir] .tab-slider--tabs:after {
  background: #8dc540;
  border-radius: 5px;
  border: 2px solid white;
}
[dir=ltr] .tab-slider--tabs:after {
  left: 0;
}
[dir=rtl] .tab-slider--tabs:after {
  right: 0;
}
[dir] .tab-slider--tabs.slide:after {
  background-color: #f85663 !important;
}
[dir=ltr] .tab-slider--tabs.slide:after {
  left: 50%;
}
[dir=rtl] .tab-slider--tabs.slide:after {
  right: 50%;
}
.tab-slider--tabs.slide:after .buy1 {
  color: #060505 !important;
}
[dir] .tab-slider--tabs.slide {
  border: 2px solid #f85663;
}
.tab-slider--trigger {
  font-size: 12px;
  font-weight: bold;
  color: #345f90;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
  display: inline-block;
  transition: color 250ms ease-in-out;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  min-width: 120px;
}
[dir] .tab-slider--trigger {
  text-align: center;
  padding: 11px 20px;
  cursor: pointer;
}
.tab-slider--trigger .active {
  color: #fff;
}
.slide .sell1 {
  color: #fff;
}
.tab-slider--tabs .buy1 {
  color: #fff;
}
.slide .buy1 {
  color: #345f90;
}
[dir] .tab-slider--body {
  margin-bottom: 20px;
}
.tab-border-color {
  /* Change the border color and style here */
}
[dir] .tab-border-color {
  border-bottom: 2px solid red;
}
</style>
